import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=2ae2e4db&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"
import style0 from "./Info.vue?vue&type=style&index=0&id=2ae2e4db&prod&scoped=true&lang=css"
import style1 from "./Info.vue?vue&type=style&index=1&id=2ae2e4db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ae2e4db",
  null
  
)

export default component.exports